module.exports = __webpack_public_path__ + "img/i-dashboard-admin.8b9f3dff.svg";